<template>
  <div class="shopinfo-box">
    <a-card :bordered="false">
      <div class="shopinfo-content">
        <h2>网站基本信息</h2>
        <a-form-model
          :model="form"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item has-feedback label="店铺名称">
            <a-input v-model="form.title" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="店铺LOGO">
            <a-input v-model="form.logo" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="店铺描述">
            <a-input v-model="form.desc" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="QQ">
            <a-input v-model="form.qq" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="微信">
            <a-input v-model="form.wechat" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="手机">
            <a-input v-model="form.phone" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="支付宝">
            <a-input v-model="form.alipay" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="setInfo(form)">保存修改</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-card>
  </div>
</template>

<script>
import { SETTING_query, SETTING_update } from "@/api/setting";
export default {
  data() {
    return {
      siteInfo: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: {
        title: "",
        logo: "",
        desc: "",
        qq: "",
        wechat: "",
        phone: "",
        alipay: ""
      }
    };
  },
  created() {},
  mounted() {
    this.getInfo({ type: "shopinfo" });
  },
  methods: {
    getInfo: function(_obj) {
      console.log(_obj);
      SETTING_query(_obj)
        .then(response => {
          this.form = response.res;
        })
        .catch(() => {});
    },
    setInfo: function(_obj) {
      SETTING_update({
        type: "shopinfo",
        info: _obj
      })
        .then(response => {
          console.log(response.res);
          if (response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.shopinfo-content {
  .btn-list {
    margin-top: 30px;
  }
}
</style>
